import uuidv4 from 'uuid/v4'
import type { Dictionary } from 'lodash'

type Iterator<T, R> = (item: T) => R | T

interface MapToDictionary<T, R> {
  array: T[]
  key: ((item: T, index?: number) => keyof T | string) | keyof T | string
  iterator?: Iterator<T, R>
}

export default function mapToDictionary<T, R>({
  array,
  key,
  iterator = x => x
}: MapToDictionary<T, R>): Dictionary<R> {
  const dict = {}
  array.forEach((x, index) => {
    const item = iterator(x)
    const dictKey = typeof key === 'function' ? key(x, index) : key
    const byKey = '' + (typeof x === 'string' ? x : x[dictKey as keyof T])
    dict[byKey] = item
  })
  return dict
}

/**
 * @description
 * Creates array with key/value properties and generated id
 *
 * @param {Object} dictionary dictionary which will be transformed to array
 * @param {Function} iterator function taking each item and should return it on iteration
 *
 * @returns array got from dictionary
 */

export function dictionaryToKeyValueArray<T, R>(
  dictionary: Dictionary<T>,
  iterator: Iterator<T, R> = item => item
): R[] {
  const array = []
  for (const key in dictionary) {
    const item = iterator(dictionary[key])
    array.push({
      id: uuidv4(),
      key,
      value: item
    })
  }
  return array
}
